import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "gamepanel" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "role" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "sub" }
const _hoisted_7 = { class: "number" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "line" }, "/", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "light" }, "1600", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "line" }, " / ", -1)
const _hoisted_11 = { class: "money" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "menu" }
const _hoisted_14 = { class: "main" }

import {playerMoney} from "@/assets/ts/utils";
import {
  position,
  roleId,
  roleName,
  emblemSpecial,
  emblemIcon,
  activeIndex,
  setActive,
  initGamePanel
} from "@/assets/ts/gamepanel";


export default /*#__PURE__*/_defineComponent({
  __name: 'GamePanelView',
  setup(__props) {

initGamePanel();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "image",
        style: _normalizeStyle({ 'background-image': `url(${_unref(emblemSpecial)})`})
      }, null, 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "icon",
          style: _normalizeStyle({ 'background-image': `url(${_unref(emblemIcon)})`})
        }, null, 4),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "emblem",
            to: "home"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(roleName)), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(roleId)) + " 号玩家", 1),
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("p", _hoisted_11, [
                  _createElementVNode("img", {
                    class: "light",
                    src: require('@/assets/images/light.png'),
                    alt: "light.png"
                  }, null, 8, _hoisted_12),
                  _createTextVNode(" 光尘货币：" + _toDisplayString(_unref(playerMoney)), 1)
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("ul", null, [
          (_unref(position) === 'captain')
            ? (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["menu-link", { 'active': _unref(activeIndex) === 1 }]),
                key: "1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setActive)(1)))
              }, [
                _createVNode(_component_router_link, {
                  to: "map",
                  target: "windows"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("地图")
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("li", {
            class: _normalizeClass(["menu-link", { 'active': _unref(activeIndex) === 2 }]),
            key: "2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setActive)(2)))
          }, [
            _createVNode(_component_router_link, {
              to: "options",
              target: "windows"
            }, {
              default: _withCtx(() => [
                _createTextVNode("操作面板")
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["menu-link", { 'active': _unref(activeIndex) === 3 }]),
            key: "3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setActive)(3)))
          }, [
            _createVNode(_component_router_link, {
              to: "deck",
              target: "windows"
            }, {
              default: _withCtx(() => [
                _createTextVNode("卡牌抽取")
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["menu-link", { 'active': _unref(activeIndex) === 4 }]),
            key: "4",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(setActive)(4)))
          }, [
            _createVNode(_component_router_link, {
              to: "decklist",
              target: "windows"
            }, {
              default: _withCtx(() => [
                _createTextVNode("持有卡牌")
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["menu-link", { 'active': _unref(activeIndex) === 5 }]),
            key: "5",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(setActive)(5)))
          }, [
            _createVNode(_component_router_link, {
              to: "bounty",
              target: "windows"
            }, {
              default: _withCtx(() => [
                _createTextVNode("悬赏任务")
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["menu-link", { 'active': _unref(activeIndex) === 6 }]),
            key: "6",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(setActive)(6)))
          }, [
            _createVNode(_component_router_link, {
              to: "playerevent",
              target: "windows"
            }, {
              default: _withCtx(() => [
                _createTextVNode("个人事件")
              ]),
              _: 1
            })
          ], 2),
          (_unref(position) === 'captain')
            ? (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["menu-link", { 'active': _unref(activeIndex) === 7 }]),
                key: "7",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(setActive)(7)))
              }, [
                _createVNode(_component_router_link, {
                  to: "globalevent",
                  target: "windows"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("全局事件")
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("li", {
            class: _normalizeClass(["menu-link", { 'active': _unref(activeIndex) === 8 }]),
            key: "8",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(setActive)(8)))
          }, [
            _createVNode(_component_router_link, {
              to: "shop",
              target: "windows"
            }, {
              default: _withCtx(() => [
                _createTextVNode("商店")
              ]),
              _: 1
            })
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_router_view, { key: "options" })
    ])
  ]))
}
}

})